export default __webpack_public_path__ + "static/media/polaroid26.84003444.jpg";